// ============================================================================
// Profil « Étudiant » en classe préparatoire (migration 0302) — PUR, testé.
// ============================================================================
// Un étudiant `formation_type='cpge'` choisit sa filière (MPSI, PTSI, MP, PT) :
// c'est son `student_profiles.level`, qui donne accès aux chapitres et aux
// SKILLCARDS de prépa. L'année d'étude en découle (MPSI/PTSI = 1, MP/PT = 2).
// Les autres formations du supérieur gardent `level = null` (aucun contenu).
// ============================================================================

import {
  CPGE_SCHOOL_LEVELS,
  type FormationType,
  type SchoolLevel,
  type SubjectSlug,
} from '@jeraisonne/db';

export const CPGE_SUBJECT: SubjectSlug = 'math-cpge';

/** Année de prépa d'un niveau CPGE (1 ou 2), `null` hors prépa. */
export function cpgeStudyYear(level: SchoolLevel | '' | null | undefined): 1 | 2 | null {
  if (level === 'mpsi' || level === 'ptsi') return 1;
  if (level === 'mp' || level === 'pt') return 2;
  return null;
}

export function isCpgeFormation(formation: FormationType | '' | null | undefined): boolean {
  return formation === 'cpge';
}

export interface HigherEdInput {
  formationType: FormationType | '';
  cpgeLevel: SchoolLevel | '';
  studyYear: number | '';
}

/** Le formulaire « Étudiant » est-il complet ? */
export function canSubmitHigherEd(input: HigherEdInput): boolean {
  if (!input.formationType) return false;
  if (isCpgeFormation(input.formationType)) return cpgeStudyYear(input.cpgeLevel) !== null;
  return Boolean(input.studyYear);
}

/** Champs `student_profiles` d'un étudiant du supérieur. */
export function higherEdProfileFields(input: HigherEdInput): {
  level: SchoolLevel | null;
  subjects: SubjectSlug[];
  formation_type: FormationType;
  study_year: number;
} {
  if (!input.formationType) throw new Error('Formation manquante.');
  if (isCpgeFormation(input.formationType)) {
    const year = cpgeStudyYear(input.cpgeLevel);
    if (year === null) throw new Error('Choisis ta filière de prépa.');
    return {
      level: input.cpgeLevel as SchoolLevel,
      subjects: [CPGE_SUBJECT],
      formation_type: 'cpge',
      study_year: year,
    };
  }
  if (!input.studyYear) throw new Error("Année d'étude manquante.");
  return {
    level: null,
    subjects: [],
    formation_type: input.formationType,
    study_year: input.studyYear,
  };
}

export { CPGE_SCHOOL_LEVELS };
